// --
import React from 'react';
import './Loader.scss';
import classNames from 'classnames';
import Icon from "../icon/FAIcon";

/**
 * Loader pro načítání dat. Pokud má obsah (children), je zobrazen jako načítací text, jinak se typicky použije implicitní.
 */
export default class Loader extends React.Component {

    static propTypes = {
        noPadding: React.PropTypes.bool,
        cardBlock: React.PropTypes.bool,    // je jako card-block
    };

    static defaultProps = {
        noPadding: false,
        cardBlock: false,
    };

    render() {
        const {noPadding, cardBlock, className, ...other} = this.props;

        const cls = classNames(
            "loader",
            className,
            {
                "no-padding": noPadding,
                "card-block": cardBlock
            }
        );
        return (
            <div className={cls} {...other}>
                <Icon icon="circle-o-notch" animation={Icon.animation.spin} fixedWidth/>
                <span>{this.props.children || "Načítají se data"}</span>
            </div>
        );
    }

};
